interface SuccessScreenProps {
    onReset: () => void;
    createdCount?: number;
  }
  
  export function SuccessScreen({ onReset, createdCount = 0 }: SuccessScreenProps) {
    return (
      <main className="flex min-h-[calc(100vh-73px)] items-center justify-center px-6">
        <div className="text-center">
          <div className="mb-6 flex justify-center">
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-gray-100">
              <svg
                className="h-10 w-10 text-black"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
          </div>

          <div className="mb-3 text-[15px] font-[500]">Suggestions Sent Successfully</div>
          <div className="mb-8 text-muted-foreground">
            {createdCount > 0
              ? `${createdCount} contractor suggestion${createdCount === 1 ? "" : "s"} created successfully.`
              : "Homeowners will receive contractor recommendations via email"}
          </div>
  
          <button
            type="button"
            onClick={onReset}
            className="contractor-primary-action rounded-lg border px-8 py-2"
          >
            Send More Suggestions
          </button>
        </div>
      </main>
    );
  }
  
